/**
 * Tuple of X and Y coordinates.
 */
export type Point = [number, number];

/**
 * Checks if given argument is assignable to Point type.
 *
 * @param candidate
 */
export function isPoint(candidate: unknown): candidate is Point {
  return (
    Array.isArray(candidate) &&
    candidate.length === 2 &&
    typeof candidate[0] === "number" &&
    typeof candidate[1] === "number"
  );
}
